import getInstance from "../config/api";

export default class Installment {
  static async fetchInstallments(params) {
    const instance = getInstance();
    const { data } = await instance.get("/installment", { params });
    return data;
  }
}
